exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TableRecord__record--vnFyS {\n  position: relative;\n  border-bottom: solid 1px #1e1f21;\n  color: #f9f9f9;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 15px;\n}\n.TableRecord__record--vnFyS:hover {\n  opacity: 0.65;\n}\n.TableRecord__record--vnFyS img {\n  vertical-align: middle;\n}", ""]);

// exports
exports.locals = {
	"record": "TableRecord__record--vnFyS"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };